import { AxiosResponse } from "axios";
import CareerConnection from "wwg-utilities/dist/collections/career-connection";
import auth from "../config/firebase";
import { getCookie } from "../cookies";
import apiClient from "./axiosClient";

const getCareerConnectionRequest = async (
  userId: string = '',
  careerId: string = '',
): Promise<CareerConnection> => {
  const token = (await auth.currentUser?.getIdToken()) || getCookie('token');

  return apiClient
    .get(`career-connections/${userId}/${careerId}`, {
      headers: {
        'Authorization-WWG': `Bearer ${token}`,
      },
    })
    .then((res: AxiosResponse) => res.data);
};

export default getCareerConnectionRequest;